import React, {FC, useEffect, useState} from "react";
import {Box, Card, makeStyles, Theme, Typography, Grid} from "@material-ui/core";
import { ReactComponent as DocSVG } from "../../Images/vetDoctor.svg";
import ScheduleIcon from "@material-ui/icons/Schedule";
import moment from "moment";
import EventNoteIcon from "@material-ui/icons/EventNote";
import {ReactComponent as StetSvg} from "../../Images/stethoscope.svg";
import {setType} from "../../Constants/serviceType";
import {setPetAge} from "../../utils/petInfo";

interface DocCardProps {
	docType: string,
	docFirstName: string,
	docLastName: string,
	docEdu: string,
	docImage: string,
	setDocImage: any,
	scheduledDate: string,
	appointmentType: string,
    animalName: string,
    dateOfBirth: string,
}

const useStyle = makeStyles((theme: Theme) => ({
    detailsContainer: {
        paddingLeft: "15%",
        [theme.breakpoints.down("xs")]: {
            paddingLeft: 0,
            alignItems: "center"
        },
    },
    docCard: {
        padding: "40px 0",
    },
    iconBox: {
        width: 25,
        height: 25,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: 14,
    },
}));

const DocCard: FC<DocCardProps> = ({docType, docFirstName, docLastName, docEdu, docImage, setDocImage, scheduledDate, appointmentType, animalName, dateOfBirth} :DocCardProps) => {
    const classes = useStyle();
    const [vetImage, setVetImage] = useState("");

    useEffect(() => {
        if(docImage) setVetImage(docImage);
    }, [docImage]);

    return (
        <Card className={classes.docCard}>
            <Grid container spacing={2}>
                <Grid item sm={12} xs={12}>
                    <Box
                        display="flex"
                        justifyContent="center">
                        {
                            vetImage ?
                                <img style={{ objectFit: "cover" }} width="120" height="120" src={vetImage} onError={() => { setVetImage(""); }} />
                                :
                                <Box width="120px" height="120px">
                                    <DocSVG />
                                </Box>
                        }
                    </Box>
                </Grid>
                <Grid item sm={12} xs={12}>
                    <Typography variant="h3" align="center">
                        {
                            docType === "vet" ? `Dr. ${docLastName}` : docFirstName
                        }
                    </Typography>
                </Grid>
                {
                    docEdu &&
				<Grid item sm={12} xs={12}>
				    <Typography align="center">
				        {docEdu}
				    </Typography>
				</Grid>
                }
                <Grid item sm={12} xs={12}>
                    <Typography variant="h4" align="center">
					Appointment Details
                    </Typography>
                </Grid>
                <Grid container wrap="nowrap" direction="column" className={classes.detailsContainer}>
                    <Grid item sm={12} alignItems="baseline" style={{maxWidth: "200px", marginTop: "16px"}}>
                        <Box>
                            <Typography dangerouslySetInnerHTML={{ __html: `<b>${animalName?.toUpperCase()} -&nbsp;</b>${setPetAge(dateOfBirth)}`}}
                                style={{whiteSpace: "pre-wrap", maxWidth: "200px", textOverflow: "ellipsis", overflow: "hidden"}}></Typography>
                        </Box>
                    </Grid>
                    <Grid item sm={12}>
                        <Box
                            display="flex"
                            flexDirection="row"
                            alignItems="center"
                            minWidth="200px"
                            marginTop="16px"
                        >
                            <Box className={classes.iconBox}>
                                <ScheduleIcon />
                            </Box>
                            <Box marginLeft="5px">
                                <Typography>
                                    {
                                        moment(scheduledDate || new Date()).format("h:mm a")}&nbsp;
								-
								&nbsp;{moment(scheduledDate || new Date()).add(20, "minutes").format("h:mm a")
                                    }
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item sm={12}>
                        <Box
                            display="flex"
                            flexDirection="row"
                            alignItems="center"
                            minWidth="200px"
                            marginTop="16px"
                        >
                            <Box className={classes.iconBox}>
                                <EventNoteIcon />
                            </Box>
                            <Box marginLeft="5px">
                                <Typography>
                                    {
                                        moment(scheduledDate || new Date()).format("dddd, MMM D")
                                    }
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item sm={12}>
                        <Box
                            display="flex"
                            flexDirection="row"
                            alignItems="center"
                            minWidth="200px"
                            marginTop="16px"
                        >
                            <Box className={classes.iconBox}>
                                <StetSvg />
                            </Box>
                            <Box marginLeft="5px">
                                <Typography>
                                    {setType(appointmentType)}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </Card>
    );
};

export default DocCard;
